<app-empty-state-standard
  *ngIf="show.emptyState"
  [isAdmin]="recoveryMode"
  [heading]="'No market stock data yet'"
  [buttonText]="'Stock ticker'"
  [buttonIconName]="'plus.svg'"
  (buttonClick)="showTickerModal()">
</app-empty-state-standard>
<app-tooltip
  *ngIf="toolTipSettings?.show"
  [coordinates]="toolTipSettings.coordinates"
  [title]="toolTipSettings.title">
</app-tooltip>
<ng-container *ngIf="!show.emptyState">
  <div
    class="vertical-container-simple column-gap-1"
    [class.padding-0p3125-1-2p5-1]="!recoveryMode">
    <div class="main pd-bttm-unset position-rel">
      <div class="cards-dropdown pd-bttm-1p25">
        <app-card-dropdown-checkbox
          data-qa="ma-ticker-dropdown-industries"
          [items]="checkBoxSelectors"
          [label]="modalTickersNames.Industries"
          (itemEmitter)="recreateFromIndustryFilter($event)">
        </app-card-dropdown-checkbox>
        <app-card-dropdown-modal
          data-qa="ma-ticker-dropdown-enterprise-value"
          [label]="modalTickersNames.EnterpriseValue"
          [infoForModal] = "infoForEnterpriseValue"
          (itemEmitter)="recreateFromModal($event, modalTickersNames.EnterpriseValue)">
        </app-card-dropdown-modal>
        <app-card-dropdown-modal
          data-qa="ma-ticker-dropdown-revenue"
          [label]="modalTickersNames.Revenue"
          [infoForModal] = "infoForRevenue"
          (itemEmitter)="recreateFromModal($event, modalTickersNames.Revenue)">
        </app-card-dropdown-modal>
        <app-card-dropdown-modal
          data-qa="ma-ticker-dropdown-revenue-growth"
          [label]="modalTickersNames.RevenueGrowthYOY"
          [infoForModal] = "infoForRevenueGrowth"
          [type]="'%'"
          (itemEmitter)="recreateFromModal($event, modalTickersNames.RevenueGrowthYOY)">
        </app-card-dropdown-modal>
      </div>
      <app-recovery-ticker-chart #chartMaTicker>
      </app-recovery-ticker-chart>
    </div>
    <div class="main">
      <div class="table-fms max-height-77vh">
        <table>
          <thead>
            <tr>
              <th class="width-1p375">
                <app-three-dots-menu
                  *ngIf="recoveryMode"
                  data-qa="three-dots-stocks-add-ma"
                  [matMenuTriggerFor]="threeDottedStocks">
                </app-three-dots-menu>
                <mat-menu #threeDottedStocks="matMenu">
                  <ul class="list">
                    <app-drop-down-item
                      [attr.data-qa]="'three-dots-stocks-add'"
                      class="width-100pcnt"
                      [iconNameAndStyling]="'plus.svg'"
                      [text]="'Add ticker'"
                      (click)="showTickerModal()">
                    </app-drop-down-item>
                  </ul>
                </mat-menu>
              </th>
              <th
                class="width-15p625"
                appSort
                [arr]="[stocks]"
                [keySelector]="StockDataMASorting.byCompanyName"
              >{{countCompanies}} Companies</th>
              <th class="width-15p625">Industry</th>
              <th
                class="width-23"
                appSort
                [arr]="[stocks]"
                [isActivated]="true"
                [order]="'asc'"
                [keySelector]="StockDataMASorting.byEnterpriseValue"
              >Enterprise Value</th>
              <th
                class="width-23"
                appSort
                [arr]="[stocks]"
                [keySelector]="StockDataMASorting.byAnnualRevenue"
              >Annual revenue</th>
              <th
                class="width-23"
                appSort
                [arr]="[stocks]"
                [keySelector]="StockDataMASorting.byRevenueIndex"
              >EV/Revenue</th>
              <th
                class="width-23"
                appSort
                [arr]="[stocks]"
                [keySelector]="StockDataMASorting.byRevenueGrowth"
              >Revenue growth YOY</th>
              <th
                class="width-23"
                appSort
                [arr]="[stocks]"
                [keySelector]="StockDataMASorting.byEbitdaRatio"
              >EBITDA/Revenue</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let tickerMAData of stocks; let i = index">
              <td>
                <app-three-dots-menu
                  *ngIf="recoveryMode"
                  data-qa="three-dots-stocks-ma"
                  [matMenuTriggerFor]="threeDottedStocks">
                </app-three-dots-menu>
                <mat-menu #threeDottedStocks="matMenu">
                  <ul class="list">
                    <app-drop-down-item
                      [attr.data-qa]="'three-dots-stocks-delete'"
                      class="width-100pcnt"
                      [iconNameAndStyling]="'edit-outline.svg'"
                      [text]="'Delete ticker'"
                      (click)="deleteTickerFroMA(tickerMAData.tickerName)">
                    </app-drop-down-item>
                    <app-drop-down-item
                      [attr.data-qa]="'three-dots-stocks-edit'"
                      class="width-100pcnt"
                      [iconNameAndStyling]="'edit.svg'"
                      [text]="'Edit ticker'"
                      (click)="showTickerModal(tickerMAData)">
                    </app-drop-down-item>
                  </ul>
                </mat-menu>
              </td>
              <td>
                <div class="start-column-container column-gap-0p15625">
                  <span class="font-4 link-color clickable" (click)="goToTickerWebsite(tickerMAData.tickerName)">
                    {{tickerMAData.companyName}}
                   </span>
                  <span class="caption-2 bold500">{{tickerMAData.tickerName}}</span>
                </div>
              </td>
              <td>
                <div class="start-row-container row-gap-0p1">
                  <app-badge *ngIf="tickerMAData.sectors && tickerMAData.sectors.length > 0"
                             [text]="tickerMAData.sectors[0].sector"
                             [size]="'small'"
                             [color]="sectorColourMap.get(tickerMAData.sectors[0].id)">
                  </app-badge>
                  <app-badge *ngIf="tickerMAData.sectors && tickerMAData.sectors.length > 1"
                             [id]="'sectors'+i"
                             (mouseenter)="activateTooltip(i, tickerMAData.sectors)"
                             (mouseleave)="hideTooltip()"
                             [text]="'+' + (tickerMAData.sectors.length - 1)"
                             [size]="'small'"
                             [color]="'#D2D5D6'">
                  </app-badge>
                </div>
              </td>
              <td> {{ tickerMAData.enterpriseValue | switcherDashBraces : 1 : 0}} </td>
              <td> {{ tickerMAData.annualRevenue | switcherDashBraces : 1 : 0}} </td>
              <td> {{ tickerMAData.revenueIndex | switcherDashBraces : 1 : 1}} </td>
              <td> {{ tickerMAData.revenueGrowth | percent: '1.0-1'  | negativeValueToBraces }} </td>
              <td> {{ tickerMAData.ebitdaRatio | switcherDashBraces : 1 : 2}} </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-container>

<app-recovery-ticker-modal
  *ngIf="show.tickerModal"
  [stockDataMA]="tickerDataForEdit"
  [allSectors]="allSectors"
  (closeEmitter)="closeModal($event)">
</app-recovery-ticker-modal>
